import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
window.__forceSmoothScrollPolyfill__ = true
